import Layout from '@layout/Index'

export const resume = [
  {
    path: '/resume',
    component: Layout,
    children: [
      {path: 'table', component: () => import('./pages/ResumeTable.vue'), name: '投递简历'},
      {path: 'detail', component: () => import('./pages/ResumeDetail.vue'), name: '管理员下单简历详情'},
      {path: 'audit-table', component: () => import('./pages/ResumeAuditTable.vue'), name: '查看简历'},
      {path: 'audit-detail', component: () => import('./pages/ResumeAuditDetail.vue'), name: '简历详情'},
      {path: 'all_table', component: () => import('./pages/ResumeAllTable.vue'), name: '全部简历'},
      {path: 'form/:id', component: () => import('./pages/ResumeForm.vue'), name: '简历编辑'},
      {path: 'all-detail', component: () => import('./pages/ResumeAllDetail.vue'), name: '全部简历详情'},
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/resume/resume.route.js